import React from "react";

/**
 * Label map for payment methods (x402 vs direct). `horus` is NOT a
 * method — it's a wallet source, switched via WalletSourceSwitcher.
 * The MethodSwitcher only toggles the on-chain settlement scheme
 * inside the external-wallet path.
 */
const METHOD_LABELS = {
  x402: (link) => `Pay gasless with ${link?.tokenSymbol || "USDC"} instead →`,
  direct: () => "Pay with direct transfer instead →",
};

/**
 * Low-contrast text link(s) rendered under the Pay button when the
 * link exposes more than one *payment method* (x402 / direct).
 *
 * Rendered only for the external-wallet source; the Horus custodial
 * path is always direct-style (backend `signTransaction` doesn't
 * sign EIP-712 typed data yet), so there's no in-source method
 * choice to surface.
 */
export function MethodSwitcher({
  link,
  activeMethod,
  availableMethods,
  onSwitch,
}) {
  const methods =
    availableMethods && availableMethods.length
      ? availableMethods
      : link?.paymentMethods || [];
  if (methods.length < 2) return null;

  const others = methods.filter((m) => m !== activeMethod);
  if (!others.length) return null;

  return (
    <div className="pay-method-switcher-group">
      {others.map((m) => {
        const labeller = METHOD_LABELS[m];
        if (!labeller) return null;
        return (
          <button
            key={m}
            type="button"
            className="pay-method-switcher"
            onClick={() => onSwitch(m)}
          >
            {labeller(link)}
          </button>
        );
      })}
    </div>
  );
}
